const hostname = window?.location?.hostname || '';

export const DomainConfig = {
  hostname,
  isCorporateUAT: hostname.includes('uatcorporate.belairtrip.com'),
  isCorporateLive: hostname.includes('corporate.belairtrip.com'),
  isCorporate:
    hostname.includes('corporate.belairtrip.com') ||
    hostname.includes('uatcorporate.belairtrip.com'),
};